import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'de' ? 'en' : 'de';
    i18n.changeLanguage(newLang);
  };

  return (
    <button 
      onClick={toggleLanguage} 
      className="language-switcher"
      data-testid="language-switcher"
    >
      {i18n.language === 'de' ? '🇬🇧 EN' : '🇩🇪 DE'}
    </button>
  );
};
